/* eslint-disable max-lines */
/* eslint-disable array-element-newline */

import {Helmet} from "react-helmet";
import ProductsHelper from "../../bundles/Product/modules/ProductsHelper";
import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class ProductDetails extends React.Component {

  static propTypes = {
    "className": PropTypes.string,
    "location": PropTypes.object,
    "orderInfo": PropTypes.object,
    "parentProps": PropTypes.object.isRequired
  };

  static defaultProps = {
    "className": null,
    "location": null,
    "orderInfo": {}
  };

  constructor (props) {
    super(props);
    const {location} = this.props;
    this.showClearanceRequested = document.cookie.indexOf("store=Clearance;") > -1 ||
                                 location.search.indexOf("from_clearance") !== -1;
  }

  /* eslint-disable prefer-destructuring */
  toggleDetailsDisplay = (event) => {
    const target = event.currentTarget;
    const querySelector = target.attributes["data-target"].value;

    $(querySelector).slideToggle();
    target.className =
      [
        "expand-btn",
        "collapse-btn"
      ].filter(el => el !== target.className)[0];
  }
  /* eslint-enable prefer-destructuring */

  getUtmParameters = () => {
    const params = window.location.search.split("&");
    const utmParams = params.filter(param => param.includes("utm")).join("&");
    return utmParams || "";
  }

  generateSlug = designer => designer.toLowerCase().split(" ").join("_");

  displayDesignerFilterLink (designerName, getsDesignerFilter) {
    return (
      getsDesignerFilter
        ? <a href={`/jewelry?designers-${this.generateSlug(designerName)}`}>
          {`Browse ${designerName} >`}
        </a> // eslint-disable-line react/jsx-closing-tag-location
        : ""
    );
  }

  otherMaterialsDisplay = (otherMaterials) => {
    let res = "";
    try {
      res = otherMaterials.split(/[\s_]/).
        map(str => str.charAt(0).toUpperCase() + str.substring(1)).
        join(" ");
    } catch (ex) {
      console.log(ex);
    }
    return res;
  }

  nonmemberShouldSeeBIN = () => {
    const {"parentProps": {buyItNowEligible}} = this.props;
    return buyItNowEligible;
  }

  isAvailableRetailStore = () => {
    const {orderInfo, "parentProps": {productDescriptor}} = this.props;
    let availableRetailStore = false;

    if (orderInfo[productDescriptor.id]) {
      availableRetailStore = orderInfo[productDescriptor.id]["retail?"];
    }

    return availableRetailStore;
  }

  isMetalFineJewelry = (metalName) => {
    if (!metalName) return false;
    return ["White Gold", "Sterling Silver"].includes(metalName);
  }

  getMetalInfo = (baseMetal, metalDetail, metalName) => {
    let metalInfo = metalDetail || metalName;

    if (baseMetal) {
      metalInfo += ` over ${baseMetal}`;
    } else if (!baseMetal && this.isMetalFineJewelry(metalName)) {
      metalInfo = `Solid ${metalName}`;
    }
    return metalInfo;
  }


  render () { // eslint-disable-line complexity
    const {
      className,
      orderInfo,
      "parentProps": {
        "productDescriptor": {
          id,
          "details": {
            "base_metal": baseMetal,
            "designer": designerName,
            "designer_bio": designerBio,
            "gets_designer_filter": getsDesignerFilter,
            "is_fine": isFine,
            "kind_name": kindName,
            length,
            "length_class": lengthClass,
            "metal_detail": metalDetail,
            "metal_name": metalName,
            "other_materials": otherMaterials,
            "styling_description": stylingDescription,
            "weight_class": weightClass
          }
        }
      }
    } = this.props;

    let availableClearanceStore = false; // eslint-disable-line no-unused-vars
    let availableRetailStore = false; // eslint-disable-line no-unused-vars

    if (orderInfo && orderInfo[id]) {
      availableClearanceStore = orderInfo[id]["clearance?"];
      availableRetailStore = orderInfo[id]["retail?"];
    }

    return (
      <React.Fragment>
        <Helmet>
          <meta
            content={`${stylingDescription}`}
            name="description"
          />
        </Helmet>
        <div
          className={className}
          id="Details"
        >
          <div className="details-item">
            <div className="details-title-header pv8">
              <h2 className="styled_h5">
                Details
              </h2>
              <span
                className="collapse-btn"
                data-target="#product-details-details"
                onClick={this.toggleDetailsDisplay}
              />
            </div>
            <div
              id="product-details-details"
            >
              {stylingDescription &&
              <div className="mv8">
                {stylingDescription}
              </div>}
              <div
                className={`${[
                  "Earrings",
                  "Necklace"
                ].indexOf(kindName) > -1
                  ? "mr64"
                  : ""} product-details`}
              >
                <div className="detail">
                  <p className="styled_h6 bold">
                    Metal:
                  </p>
                  <p className="styled_h6 ml16">
                    {this.getMetalInfo(baseMetal, metalDetail, metalName)}
                  </p>
                </div>
                {kindName !== "Ring" && length &&
                <div className="detail">
                  <p className="styled_h6 bold">
                    Size:
                  </p>
                  <p className="styled_h6 ml16">
                    {length}
                  </p>
                </div>}
                {otherMaterials &&
                <div className="detail">
                  <p className="styled_h6 bold">
                    Material:
                  </p>
                  <p className="styled_h6 ml16">
                    {this.otherMaterialsDisplay(otherMaterials)}
                  </p>
                </div>}
              </div>
              {kindName === "Earrings" && weightClass &&
              <div className="sillhouette earrings">
                <p className="styled_h6 bold left mb16">
                  Weight:
                </p>
                <img
                  alt={weightClass}
                  src={`/assets/roxy/product_descriptors/sillhouettes/${weightClass}.svg`}
                />
                <p className="tiny pull-left">
                  Light
                </p>
                <p className="tiny weight-heavy">
                  Heavy
                </p>
              </div>}
              {kindName === "Necklace" && lengthClass &&
              <div className="sillhouette necklaces">
                <img
                  alt={lengthClass}
                  src={`/assets/roxy/product_descriptors/sillhouettes/${lengthClass}.svg`}
                />
              </div>}
              <div className="mt8 mb24">
                {otherMaterials && otherMaterials.indexOf("natural_stone") > -1 &&
                  <div>
                    **Exact color patterns may vary slightly from the image shown due
                    to the one-of-a-kind nature of the medium.
                  </div>}
                {isFine &&
                  <div>
                    **This item is electroplated with rhodium or finished with an e-coating.
                    These finishes may wear off with frequent use.
                  </div>}
              </div>
            </div>
          </div>
          {ProductsHelper.icons[designerName] &&
          <div className="details-item">
            <div className="details-title-header pv8">
              <h2 className="styled_h5">
                About the Designer
              </h2>
              <span
                className="expand-btn"
                data-target="#product-details-designer"
                onClick={this.toggleDetailsDisplay}
              />
            </div>
            <div
              className="pb24 product-details-designer"
              id="product-details-designer"
              style={{"display": "none"}}
            >
              <div className="designer-info">
                <img src={`/assets/roxy/product_descriptors/designer_logos/${designerName}.svg`} />
                <link
                  href={`/assets/roxy/product_descriptors/designer_logos/${designerName}.svg`}
                  rel="prefetch"
                />
                <p>
                  {designerBio}
                </p>
                {this.displayDesignerFilterLink(designerName, getsDesignerFilter)}
              </div>
              <div className="designer-icons">
                {ProductsHelper.icons[designerName].map(icon =>
                  <div key={icon}>
                    <img
                      className="inline-block mh24"
                      src={`/assets/roxy/product_descriptors/designer_icons/${icon}.svg`}
                    />
                    <link
                      href={`/assets/roxy/product_descriptors/designer_icons/${icon}.svg`}
                      rel="prefetch"
                    />
                    <p className="small inline-block averta-regular">
                      {ProductsHelper.iconText(icon)}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({"orderInfo": state.orderInfo});

export default connect(mapStateToProps)(withRouter(ProductDetails));
